import { useQuery } from "react-query";
import { INotificationMessageModel } from "../../services/notification-message-service/Models";
import NotificationMessageService from "../../services/notification-message-service/NotificationMessageService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";

import { keys } from "./Keys";

export type UseNotificationMessageParameters = {
    groupID: number,
} & BaseUseQueryParameters<INotificationMessageModel[]>;

export function useNotificationMessages({
    groupID,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseNotificationMessageParameters) {
    return useQuery<INotificationMessageModel[], RestError, INotificationMessageModel[]>(
        keys.list(groupID),
        ({ signal }) => {
            return NotificationMessageService.get(groupID, signal);
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false
        }
    );
}
